function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { createRef } from "react";
import ReactDOM from 'react-dom';
import "./Tooltip.css"; // const Tooltip = ({ message }) => {
//   const [visible, setVisible] = useState(false);
//   const [x, setX] = useState(0);
//   const [y, setY] = useState(0);
//   const [type, setType] = useState("none");
//   /* pre -render */
//   let visibility = state.visible == true ? "on" : "off";
//   let style = {
//     left: ((state.x + window.scrollX) + 'px'),
//     top: ((state.y + window.scrollY) + 'px')
//   };
//   let classNames = {};
//   if (type != null && type != "none") {
//     classNames[type] = true;
//   }
//   classNames[visibility] = true;
//   return (
//     <div id="tooltip" className={Object.keys(classNames).join(" ")} style={style}>
//       <div className="tooltip-arrow"></div><div className="tooltip-inner">{message}</div>
//     </div>
//   )
//     pastShow(hoverRect)
//   {
//   	// position the tooltip after showing it
//     let ttNode = ReactDOM.findDOMNode(this);
//   	if(ttNode != null)
//     {
//       let x = 0, y = 0;
//       const docWidth = document.documentElement.clientWidth,
//             docHeight = document.documentElement.clientHeight;
//       let rx = hoverRect.x + hoverRect.width, // most right x
//       		lx = hoverRect.x, // most left x
//           ty = hoverRect.y, // most top y
//           by = hoverRect.y + hoverRect.height; // most bottom y
//       // tool tip rectange
//       let ttRect = ttNode.getBoundingClientRect();
//       let bRight = (rx + ttRect.width) <= (window.scrollX + docWidth);
//       let bLeft = (lx - ttRect.width) >= 0;
//       let bAbove = (ty - ttRect.height) >= 0;
//       let bBellow = (by + ttRect.height) <= (window.scrollY + docHeight);
//       let newState = {};
//       // the tooltip doesn't fit to the right
//       if(bRight)
//       {
//       	x = rx;
//         y = ty + (hoverRect.height - ttRect.height);
//       	if(y < 0)
//         {
//         	y = ty;
// 				}
//         newState.type = "right";
//       }
//       else if(bBellow)
//       {
//       	y = by;
//         x = lx + (hoverRect.width - ttRect.width);
//         if(x < 0)
//         {
//         	x = lx;
// 				}
//         newState.type = "bottom";
//       }
//       else if(bLeft)
//       {
//       	x = lx - ttRect.width;
//         y = ty + (hoverRect.height - ttRect.height);
//         if(y < 0)
//         {
//         	y = ty;
// 				}
//         newState.type = "left";
//       }
//       else if(bAbove)
//       {
//       	y = ty - ttRect.height;
//         x = lx + (hoverRect.width - ttRect.width);
//         if(x < 0)
//         {
//         	x = lx;
// 				}
//         newState.type = "top";
//       }
//       newState = {...newState, x:x, y:y};
//       this.setState(newState);
//     }
//   }
//   show(hoverRect)
//   {
//   	let {pastShow} = this;
//     // setState will execute the pastShow with hoverRect as the tool tip becomes visible
//     setVisible(true);
//   	this.setState({visible:true}, pastShow.bind(this, hoverRect))
// 	}
//  	hide()
//   {
//   	this.setState({visible:false})
//   }
// }

var ToolTipWrapper = function ToolTipWrapper(props) {
  var message = props.message;
  var reference = props.reference;

  var handleHover = function handleHover(evt) {
    if (message === null) {
      return;
    }

    var el = evt.currentTarget;

    if (el != null) {
      var rect = el.getBoundingClientRect();

      if (reference.current != null) {
        reference.current.show(rect, message);
      }
    }
  };

  var handleHoverOut = function handleHoverOut() {
    reference.current.hide();
  };

  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: function onMouseEnter(evt) {
      handleHover(evt);
    },
    onMouseLeave: handleHoverOut,
    className: "tooltip_wrapper"
  }, props.children);
}; // Class Component


var ToolTip = /*#__PURE__*/function (_React$Component) {
  _inherits(ToolTip, _React$Component);

  var _super = _createSuper(ToolTip);

  function ToolTip(props) {
    var _this;

    _classCallCheck(this, ToolTip);

    _this = _super.call(this, props);
    _this.state = {
      visible: false,
      x: 0,
      y: 0,
      type: "bottom",
      isBellow: false,
      message: "No Message"
    };
    _this.toolTipRef = createRef();
    _this.pastShow = _this.pastShow.bind(_assertThisInitialized(_this));
    _this.isVisible = _this.isVisible.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ToolTip, [{
    key: "render",
    value: function render() {
      var state = this.state;
      var visibility = state.visible == true ? "on" : "off";
      var style = {
        left: state.x + window.scrollX + 'px',
        top: state.y + window.scrollY + 'px'
      };
      var classNames = {};

      if (state.type != null && state.type != "none") {
        classNames[state.type] = true;
      }

      classNames[visibility] = true;
      return /*#__PURE__*/React.createElement("div", {
        id: "tooltip",
        ref: this.toolTipRef,
        className: Object.keys(classNames).join(" "),
        style: style
      }, this.props.dynamicPointer ? /*#__PURE__*/React.createElement("div", {
        className: "tooltip-arrow",
        style: this.state.isBellow ? {
          top: "10%"
        } : {
          top: "90%"
        }
      }) : /*#__PURE__*/React.createElement("div", {
        className: "tooltip-arrow"
      }), /*#__PURE__*/React.createElement("div", {
        className: "tooltip-inner"
      }, this.state.message));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "pastShow",
    value: function pastShow(hoverRect) {
      var ttNode = this.toolTipRef.current;

      if (ttNode != null) {
        var x = 0,
            y = 0;
        var docWidth = document.documentElement.clientWidth,
            docHeight = document.documentElement.clientHeight;
        var rx = hoverRect.x + hoverRect.width,
            // most right x
        lx = hoverRect.x,
            // most left x
        ty = hoverRect.y,
            // most top y
        by = hoverRect.y + hoverRect.height; // most bottom y
        // tool tip rectange

        var ttRect = ttNode.getBoundingClientRect();
        var bRight = rx + ttRect.width <= window.scrollX + docWidth;
        var bLeft = lx - ttRect.width >= 0;
        var bAbove = ty - ttRect.height >= 0;
        var bBellow = by + ttRect.height <= window.scrollY + docHeight;
        var newState = {}; // the tooltip doesn't fit to the right

        if (bRight) {
          x = rx;
          y = ty + (hoverRect.height - ttRect.height);

          if (y < 0) {
            y = ty;

            if (this.props.dynamicPointer != undefined) {
              newState.isBellow = true;
            }
          } else {
            if (this.props.dynamicPointer != undefined) {
              newState.isBellow = false;
            }
          }

          newState.type = "right";
        } else if (bBellow) {
          y = by;
          x = lx + (hoverRect.width - ttRect.width);

          if (x < 0) {
            x = lx;
          }

          newState.type = "bottom";
        } else if (bLeft) {
          x = lx - ttRect.width;
          y = ty + (hoverRect.height - ttRect.height);

          if (y < 0) {
            y = ty;
          }

          newState.type = "left";
        } else if (bAbove) {
          y = ty - ttRect.height;
          x = lx + (hoverRect.width - ttRect.width);

          if (x < 0) {
            x = lx;
          }

          newState.type = "top";
        }

        newState = _objectSpread(_objectSpread({}, newState), {}, {
          x: x,
          y: y
        });
        this.setState(newState);
      }
    }
  }, {
    key: "show",
    value: function show(hoverRect, message) {
      var pastShow = this.pastShow; // setState will execute the pastShow with hoverRect as the tool tip becomes visible

      this.setState({
        visible: true,
        message: message
      }, pastShow.bind(this, hoverRect));
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.state.visible;
    }
  }]);

  return ToolTip;
}(React.Component);

export { ToolTip, ToolTipWrapper };